// Envio seguro do /funil-formulario (e /Captura-01-A): duas funções independentes
// (banco e webhook) com o mesmo submission_id. Navegador não acessa banco nem n8n.

const TRACK_KEYS = [
  "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
  "fbclid", "gclid", "ttclid", "msclkid", "vk_source", "vk_ad_id",
] as const;

const getTracking = () => {
  const p = new URLSearchParams(window.location.search);
  const out: Record<string, string> = {};
  for (const k of TRACK_KEYS) {
    let v = p.get(k) || "";
    if (!v) {
      try { v = sessionStorage.getItem(k) || localStorage.getItem(k) || ""; } catch { v = ""; }
    }
    out[k] = v;
  }
  return out;
};

export async function submitCaptura01A(opts: {
  nome: string;
  email: string;
  telefone: string;
  areaAtuacao: string;
  submissionId: string;
}) {
  const { supabase } = await import("@/integrations/supabase/client");

  const body = {
    nome: opts.nome,
    email: opts.email,
    telefone: opts.telefone,
    area_atuacao: opts.areaAtuacao,
    submission_id: opts.submissionId,
    page_url: `${window.location.origin}${window.location.pathname}`,
    referrer: document.referrer || "",
    ...getTracking(),
  };

  const [db, wh] = await Promise.allSettled([
    supabase.functions.invoke("submit-funil-formulario-amplificador", { body }),
    supabase.functions.invoke("send-funil-formulario-amplificador-webhook", { body }),
  ]);

  const dbOk = db.status === "fulfilled" && !db.value.error && db.value.data?.success;
  const whOk = wh.status === "fulfilled" && !wh.value.error && wh.value.data?.success;

  // Lead é considerado salvo se ao menos um destino recebeu; senão, erro (retry reutiliza o id).
  if (!dbOk && !whOk) throw new Error("submit_failed");
  return { success: true, submissionId: opts.submissionId, dbOk, whOk };
}
